import { useDetailPageStore } from '@/page/detail/store';
import React from 'react';
import { View, Text, ScrollView } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import ArrowRight from '@/assets/icon_detail/kibt_post_music_right_white2.png';
import { KImage, KImageBackground } from '@/component/RtlLayout';
import { Box } from '@kibt/meta-ui-krn';
import { $k18n } from '@/common/i18n';
import { scaleW } from '@/common/style';
import { isAndroid } from '@kibt/krn-utils';
import { getQuery } from '@/common/const';
import { KTouchableWithoutFeedback } from '@/component/RtlLayout/Touchable';
import { HorizontalProductCard } from '@/business-components/ProductCard/HorizontalProductCard/HorizontalProductCard';
import { openUrlV2 } from '@/common/bridge/openUrl';
import { useDetailLogger } from '../../../logger3.0';
import { ViewVisible } from '@/component/ViewVisible/ViewVisible';
import { useCallApp } from '@/common/callApp';

export const RankImage = (props: { ifClick?: boolean }) => {
    const { ifClick = true } = props;

    const { logClickRankBtn, logShowRankProduction, logClickRankProduction, logShowRankImage } = useDetailLogger();
    const pageRawData = useDetailPageStore(s => s.pageRawData);

    const masterPhotoCategoryRankPageInfo = pageRawData.masterPhotoCategoryRankPageInfo;
    const { callApp } = useCallApp();

    const styleConfig = {
        CATEGORY_HEAT_RISE: {
            fontColor: 'rgba(255, 255, 255, 1)',
            linearGradientColor: ['rgba(255, 255, 255, 0)', 'rgba(253, 93, 15, 1)'],
        },
        CATEGORY_TOP: {
            fontColor: 'rgba(255, 237, 157, 1)',
            linearGradientColor: ['rgba(255, 255, 255, 0)', 'rgba(0, 0, 0, 1)'],
        },
    };

    const currentStyle = styleConfig[masterPhotoCategoryRankPageInfo.rankingType] || styleConfig.CATEGORY_HEAT_RISE;
    return (
        <KImageBackground
            source={{ uri: masterPhotoCategoryRankPageInfo.backImageUrl }}
            style={{"height":"100.00000000000001rem","width":"100.00000000000001rem"}}
            resizeMode="stretch">
            <KTouchableWithoutFeedback
                onPress={() => {
                    callApp({ pageId: 'ecomm_commodity_detail' });
                }}>
                <ViewVisible onVisible={() => logShowRankImage()}>
                    <View style={{"height":"100.00000000000001rem","width":"100.00000000000001rem","position":"relative","alignItems":"center"}}>
                        <View
                            style={{
                                marginTop: isAndroid && getQuery('isHalf') === '1' ? scaleW(58) : scaleW(102),
                                width: scaleW(376),
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'flex-end',
                                height: scaleW(34),
                            }}>
                            <KImage
                                source={{ uri: 'https://cdn-static.ap4r.com/kos/s101/nlav11312/shop-krn/rankSwiperLeftV2.png' }}
                                style={{"width":"6.76328502415459rem","height":"8.212560386473431rem"}}
                            />
                            <Text
                                style={{
                                    lineHeight: scaleW(28),
                                    fontSize: scaleW(24),
                                    fontWeight: '700',
                                    color: currentStyle.fontColor,
                                    marginHorizontal: scaleW(13),
                                }}>
                                {masterPhotoCategoryRankPageInfo.title}
                            </Text>
                            <KImage
                                source={{ uri: 'https://cdn-static.ap4r.com/kos/s101/nlav11312/shop-krn/rankSwiperRightV2.png' }}
                                style={{"width":"6.76328502415459rem","height":"8.212560386473431rem"}}
                            />
                        </View>
                        <View
                            style={{"paddingTop":"2.8985507246376816rem","paddingBottom":"3.8647342995169085rem","alignItems":"center"}}>
                            <Text
                                style={{
                                    fontSize: scaleW(15),
                                    lineHeight: scaleW(16),
                                    fontWeight: '500',
                                    textAlign: 'center',
                                    maxWidth: scaleW(260),
                                    color: currentStyle.fontColor,
                                }}
                                numberOfLines={2}>
                                {masterPhotoCategoryRankPageInfo.secondTitle}
                            </Text>
                        </View>
                        <View
                            style={{
                                // 1. 沉浸式商详页是从屏幕顶部开始绘制的，所以需要留出更大的空间，防止navbar遮挡CommentImage的图文
                                // 2. 安卓的半屏推全屏容器不支持沉浸式，所以需要需要把非沉浸式商详这里的展示调整一下
                                width: scaleW(376),
                                height: isAndroid && getQuery('isHalf') === '1' ? scaleW(296) : scaleW(256),
                            }}>
                            <View
                                style={{"flex":1,"maxHeight":"39.613526570048315rem"}}>
                                <ScrollView
                                    style={{"flex":1,"position":"relative"}}
                                    showsVerticalScrollIndicator={false}>
                                    {masterPhotoCategoryRankPageInfo?.rankProducts.map((product, index) => {
                                        return (
                                            <ViewVisible
                                                onVisible={() => {
                                                    logShowRankProduction({
                                                        index: index + 1,
                                                        item_id: product.itemId,
                                                        media_source: 83,
                                                    });
                                                }}>
                                                <Box
                                                    activeOpacity={1}
                                                    style={{"marginBottom":"1.9323671497584543rem"}}>
                                                    <HorizontalProductCard
                                                        product={product}
                                                        rank={index + 1}
                                                        onClick={() => {
                                                            if (ifClick) {
                                                                logClickRankProduction({
                                                                    index: index + 1,
                                                                    item_id: product.itemId,
                                                                    media_source: 83,
                                                                });
                                                                openUrlV2({
                                                                    url:
                                                                        product.productDetailJumpUrl +
                                                                        `&extParams=${encodeURIComponent(
                                                                            JSON.stringify({ cT: 83, cId: pageRawData.itemId, cS: 1 })
                                                                        )}`,
                                                                });
                                                            }
                                                        }}
                                                    />
                                                </Box>
                                            </ViewVisible>
                                        );
                                    })}
                                </ScrollView>
                                <LinearGradient
                                    style={{"position":"absolute","bottom":"-0.24154589371980678rem","width":"100%","height":"3.8647342995169085rem"}}
                                    colors={currentStyle.linearGradientColor}
                                    start={{ x: 0, y: 0 }}
                                    end={{ x: 0, y: 1 }}
                                />
                            </View>
                        </View>

                        <View
                            style={{"position":"absolute","bottom":"1.9323671497584543rem","alignSelf":"flex-start","zIndex":10}}>
                            <View
                                style={{"justifyContent":"center","alignItems":"center","flexDirection":"row","height":"8.695652173913045rem","marginLeft":"4.5893719806763285rem"}}>
                                <Text
                                    style={{"lineHeight":"5.797101449275363rem","color":"white"}}>
                                    {$k18n({ id: 'k_1050287', text: '查看更多评价' })}
                                </Text>
                                <KImage source={ArrowRight} style={{"width":"5.797101449275363rem","height":"5.797101449275363rem"}} />
                            </View>
                        </View>
                    </View>
                </ViewVisible>
            </KTouchableWithoutFeedback>
        </KImageBackground>
    );
};
